import React from 'react';

type CloseIconProps = {
    className?: string;
};

export function CloseIcon({ className }: CloseIconProps) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 13.478 16"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M4.72921 4.71752C5.37631 5.36441 5.74258 6.24151 5.74647 7.15228L5.76446 8.82343C5.76473 9.73534 5.40133 10.6134 4.7562 11.2582L3.18309 12.8295C3.14406 12.8683 0.339689 15.6551 0 15.9946L0.000899432 14.8208C0.000700925 13.9093 0.363558 13.0335 1.00826 12.3888C1.37551 12.0218 1.82013 11.5926 1.83214 11.5811L5.41818 7.99505C4.44334 7.02546 1.81726 4.41737 1.79527 4.39553L1.02535 3.60942C0.37824 2.96249 0.0119392 2.08548 0.00809489 1.17466L0.0026983 0C0.344219 0.34152 3.12662 3.11857 3.14891 3.14082L4.72921 4.71752Z"
                fill="currentColor"
            />
            <path
                d="M13.4771 1.17916C13.4773 2.0907 13.1144 2.96652 12.4697 3.61122C12.1033 3.97746 11.6597 4.40558 11.6458 4.41891L8.05981 8.00315C9.03394 8.97203 11.6607 11.5826 11.6827 11.6045L12.4526 12.3906C13.0998 13.0375 13.4661 13.9145 13.4699 14.8253L13.4753 16C13.1338 15.6585 10.3514 12.8814 10.3291 12.8592L8.74878 11.2825C8.10166 10.6356 7.73539 9.75852 7.73152 8.84771L7.71353 7.17657C7.71326 6.26485 8.07601 5.38749 8.72089 4.74271L10.294 3.1714C10.294 3.1714 13.1363 0.346878 13.478 0.00539659L13.4771 1.17916Z"
                fill="currentColor"
            />
        </svg>
    );
}
